export default __webpack_public_path__ + "locales/it/DowngradePlanDialog.json?hash=971c79bbdbe031cd8c49bb247caf0c6a";